import { BaseState } from "src/models";

export const asyncIsPending = (state: BaseState) => {
  state.status = 'pending';
}

export const asyncIsRejected = (state: BaseState, action: any) => {
  console.log('REJECTED:: ', action);
  state.status = 'rejected';
  state.message = action.payload?.message;
}

export const asyncIsFulfilled = (state: BaseState, action: any) => {
  console.log('FULFILLED:: ', action.payload?.message);
  state.status = 'fulfilled';
  state.action = undefined;
  state.message = action.payload?.message;
}